export enum ACTION_TYPE {
    ADD_ACTION = "ADD_ACTION",
    UPDATE_ACTION = "UPDATE_ACTION"
}

export enum USER_TYPE {
    ADMIN = "Admin",
    USER = "User"
}

export enum REPORT_NAME {
    // Master reports
    ORGANIZATION_MASTER = "Organization Master",
    USER_MASTER = "User Master",
    USER_GROUP = "User Group",
    USER_SUBSCRIBER = " User Subscriber",//user role
    USER_PACKAGE = 'Package',

    //Master
    ENTITY_MASTER = "Entity Master",
    ENTITY_TYPE_MASTER = "Entity Type Master",
    INVESTMENT_MANDATE_TYPE = "Investment Mandate Type",
    INVESTMENT_MASTER = "Investment Master",
    ASSETS = "Assets",
    ASSET_TYPE = "Asset Type",
    RISK_ASSESSMENT_LOG = "Report Assessment Log",
    ENTITY_CAP = "Entity Cap",

    DOCUMENT_TYPE = "Document Type",
    DOCUMENT_MASTER = "Document Master",

    SPONSOR_MASTER = "Sponsor Master",
    FAMILY_OFFICE_MASTER = "Family Office Master",

    OPPORTUNITY_TYPE = "Opportunity Type",
    OPPORTUNITY_MASTER = "Opportunity Master",
    OPPORTUNITY_APPLICATION = "Opportunity Application",
    OPPORTUNITY_APPLICANT_INTERVIEW = "Opportunity Applicant Interview",
    OPPORTUNITY_ALLOCATION = "Opportunity Allocation",
    MEMBER_INTERVIEW_RECORDS = "Member Interview Records",
    MENTORSHIP_MASTER = "Mentorship Master",
    EVENT_MASTER = "Event Master",
    EVENT_TYPE = "Event Type",
    SOVEREIGN_EVENT_LEDGER = "Sovereign Event Ledger",

    // Dashboard
    DASHBOARD_OVERVIEW = "Overview",
    DASHBOARD_SUCCESSION = "Succession",
    DASHBOARD_WEALTH_STABILITY = "Wealth Stability",
    DASHBOARD_PROJECTS = "Projects",
    DASHBOARD_CAP_TABLE = "Cap Table",
    DASHBOARD_AUDITS = "Audits",
    DASHBOARD_MENTORSHIP = "Mentorship",
    DASHBOARD_PASSIONIT_SCORE = "PassionIT Score",

    // Common
    COUNTRY = 'Country',
    STATE = 'State',
}

export enum REPORT_PATH {

    ORGANIZATION_MASTER = "organization-master",

    //User Master report 
    USER_MASTER = "user",
    USER_GROUP = "user-group",
    USER_SUBSCRIBER = "user-subscriber",

    //Master
    ENTITY_MASTER = "entity-master",
    ENTITY_TYPE_MASTER = "entity-type-master",
    INVESTMENT_MANDATE_TYPE = "investment-mandate-type",
    INVESTMENT_MASTER = "investment-master",
    SPONSOR_MASTER = "sponsor-master",
    FAMILY_OFFICE_MASTER = "family-office-master",
    ASSETS = "assets",
    ASSET_TYPE = "asset-type",
    DOCUMENT_TYPE = "document-type",
    DOCUMENT_MASTER = "document-master",
    RISK_ASSESSMENT_LOG = "risk-assessment-log",
    ENTITY_CAP = "entity-cap",

    OPPORTUNITY_TYPE = "opportunity-type",
    OPPORTUNITY_MASTER = "opportunity-master",
    OPPORTUNITY_ALLOCATION = "opportunity-allocation",
    OPPORTUNITY_APPLICATION = "opportunity-application",
    OPPORTUNITY_APPLICANT_INTERVIEW = "opportunity-applicant-interview",
    MEMBER_INTERVIEW_RECORDS = "member-interview-records",
    MENTORSHIP_MASTER = "mentorship-master",
    EVENT_MASTER = "event-master",
    EVENT_TYPE = "event-type",
    SOVEREIGN_EVENT_LEDGER = "sovereign-event-ledger",

    // Dashboard
    DASHBOARD_OVERVIEW = "overview",
    DASHBOARD_SUCCESSION = "succession",
    DASHBOARD_WEALTH_STABILITY = "wealth-stability",
    DASHBOARD_PROJECTS = "projects",
    DASHBOARD_CAP_TABLE = "cap-table",
    DASHBOARD_AUDITS = "audits",
    DASHBOARD_MENTORSHIP = "mentorship",
    DASHBOARD_PASSIONIT_SCORE = "passionit-score",

    COUNTRY = 'country',
    STATE = 'state',
}

export enum PAGE_TITLE {
    FORGOT_PASSWORD = "Forgot Password",
    RESET_PASSWORD = "Reset Password",
}

export enum TEMPLATE_FILE_NAME {
    VALUE_CHAIN_CATEGORY = 'VALUE_CHAIN_CATEGORY',
    VALUE_CHAIN = 'VALUE_CHAIN',
    RESPONSIBILITY_GROUP = 'RESPONSIBILITY_GROUP',
    RESPONSIBILITY_CENTER = 'RESPONSIBILITY_CENTER',

    ENTITY_MASTER = "ENTITY_MASTER",
    ENTITY_TYPE_MASTER = "ENTITY_TYPE_MASTER",
    INVESTMENT_MANDATE_TYPE = "INVESTMENT_MANDATE_TYPE",
    INVESTMENT_MASTER = "INVESTMENT_MASTER",
    ASSETS = "ASSETS",
    ASSET_TYPE = "ASSET_TYPE",
    MENTORSHIP_MASTER = "MENTORSHIP_MASTER",
    EVENT_MASTER = "EVENT_MASTER",
    EVENT_TYPE = "EVENT_TYPE",

    DOCUMENT_TYPE = "DOCUMENT_TYPE",
    DOCUMENT_MASTER = "DOCUMENT_MASTER",

    SPONSOR_MASTER = "SPONSOR_MASTER",
    FAMILY_OFFICE_MASTER = "FAMILY_OFFICE_MASTER",
}